// extracted by mini-css-extract-plugin
module.exports = {"item":"AppliedFiltersItem_item__HnQ5p","label":"AppliedFiltersItem_label__2vAIo","resetIcon":"AppliedFiltersItem_resetIcon__lnuby"};